import React from 'react';
import { useTranslation } from 'react-i18next';

const ExportStatusMessage = () => {
  const { t } = useTranslation(['exportList']);
  return (
    <section className="export-status" data-testid="export-status">
      <div className="export-status__content">
        <div className="export-status__icon">
          <div className="vbz-icon-beneficiaries-large-empty-cloud-large" />
        </div>
        <div className="export-status__message">
          <h3 className="export-status__message-title" data-testid="download-title">
            {t('downloading')}
          </h3>
          <span className="export-status__message-description" data-testid="download-description">
            {t('wait_time')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default ExportStatusMessage;
